import styled from 'styled-components';

import { Text18 } from '../../ui/Text18';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Content = styled.div`
  width: 90%;
  max-width: 1400px;
  min-width: 320px;
  margin-top: 200px;
  display: flex;
  align-items: center;
  text-align: center;

  @media (max-width: 1035px) {
    flex-direction: column-reverse;
  }
`;

export const ImageWrapper = styled.div`
  @media (max-width: 1035px) {
    margin-top: 50px;
  }
`;

export const Image = styled.img`
  height: 500px;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const InfoTitle = styled.h1`
  margin-bottom: 50px;
`;

export const InfoDesc = styled(Text18)`
  font-weight: 400;
`;

export const ButtonWrapper = styled.div`
  margin-top: 48px;
  width: 500px;
`;